
// Set the defaults here
const transitionClass = 'transition duration-300 ease-in-out'
export const linkClassDefault = `no-underline ${transitionClass}`
export const itemClassDefault = `inline`
export const breadcrumbSeparatorDefault = `»`

export default {
  name: 'CmsBreadcrumb',
  props: {
    listElement: {
      type: String,
      default: 'ol',
    },
    listAttrs: {
      type: Object,
      default: () => ({}),
    },
    listItemAttrs: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [
        {
          label: 'Home',
          url: '/',
          isNuxtLink: false,
        },
      ],
    },
    contentClass: {
      type: String,
      default: '',
    },
    itemClass: {
      type: String,
      default: 'inline',
    },
    linkClass: {
      type: String,
      default: linkClassDefault,
    },
    nuxtLinkClass: {
      type: String,
      default: linkClassDefault,
    },
    breadcrumbSeparator: {
      type: String,
      default: breadcrumbSeparatorDefault,
    },
  },
}
